export default {"src":"/_next/static/image/public/images/ic_records_blue_vertical_menu.9e184d14b261c17e18ae318061dc4077.svg","height":20,"width":20};